import { render } from "./PageDetails.vue?vue&type=template&id=a393e16e&ts=true"
import script from "./PageDetails.vue?vue&type=script&lang=ts"
export * from "./PageDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__